if (!window.pkgCopyComponent) {
    window.pkgCopyComponent = function (btn, textToCopy) {
        if (btn.disabled) return;
        btn.disabled = true;

        const idle = btn.querySelector('.icon-idle');
        const loading = btn.querySelector('.icon-loading');
        const success = btn.querySelector('.icon-success');
        const toast = btn.querySelector('.copied-toast');

        idle.classList.remove('active');
        loading.classList.add('active');

        navigator.clipboard.writeText(textToCopy.trim()).then(() => {
            setTimeout(() => {
                loading.classList.remove('active');
                success.classList.add('active');
                toast.classList.add('active');
                btn.classList.remove('text-base-medium');
                btn.classList.add('text-success');

                setTimeout(() => {
                    success.classList.remove('active');
                    toast.classList.remove('active');
                    idle.classList.add('active');
                    btn.classList.remove('text-success');
                    btn.classList.add('text-base-medium');
                    btn.disabled = false;
                }, 1800);
            }, 400);
        }).catch(err => {
            console.error('Failed to copy: ', err);
            loading.classList.remove('active');
            idle.classList.add('active');
            btn.disabled = false;
        });
    }
}